const INITIAL_STATE = {
    modalOpened: null,    
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'MODAIS_OPEN':
            return { ...state, modalOpened: action.payload }
        case 'MODAIS_CLOSE':
            return { ...state, modalOpened:  null }  
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/modaisReducer.js